export function getMaskedCardNumber(firstFour?: string, lastFour?: string) {
  return firstFour && lastFour ? firstFour + ' **** **** ' + lastFour : 'XXXX XXXX XXXX XXXX';
}
